// extracted by mini-css-extract-plugin
export default {"fadeIn":"StringTwinkle_fadeIn__7PK23","fade-in":"StringTwinkle_fade-in__NIMNP","twinkle":"StringTwinkle_twinkle__VSgHu"};